import { render, staticRenderFns } from "./SousMenuOffreFormation.vue?vue&type=template&id=32127342&scoped=true"
import script from "./SousMenuOffreFormation.vue?vue&type=script&lang=js"
export * from "./SousMenuOffreFormation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32127342",
  null
  
)

export default component.exports